<template lang='pug' src='./Quote.pug'></template>

<script>
  import Vue from 'vue'
  import { mapGetters, mapActions } from 'vuex'
  import date from '../../directives/date'

  export default {
    props: ['quote'],
    directives: {
      date
    },
    data: function () {
      return {
        deleteQuoteBox: false
      }
    },
    computed: {
      ...mapGetters([
        'getActiveQuote'
      ]),
      stars: function (vote) {
        let starsSelected = 0
        if (this.quote.myVote && this.quote.myVote.vote) {
          starsSelected = this.quote.myVote.vote
        }

        return starsSelected
      },
      totalStars: function () {
        return Array.from(
          { length: Vue.config.kQuotes.TOTAL_STARS },
          (v, index) => index + 1
        ).reverse()
      }
    },
    methods: {
      showDeleteQuote: function () {
        this.deleteQuoteBox = true
      },
      hideDeleteQuote: function () {
        this.deleteQuoteBox = false
      },
      showEditQuote: function () {
        this.setActiveQuote(this.quote)
        this.setChangeQuotes(true)
      },
      newVote: function (vote) {
        this.voteQuote({ quote: this.quote, vote: vote })
      },
      removeQuote: function () {
        this.deleteQuote(this.quote)
        this.hideDeleteQuote(this.quote)
      },
      ...mapActions([
        'voteQuote',
        'deleteQuote',
        'setActiveQuote',
        'setChangeQuotes',
        'setDeleteQuote'
      ])
    }
  }
</script>

<style lang='css' src='./Quote.css' scoped></style>



// WEBPACK FOOTER //
// Quote.vue?9c0fe248